import { GET_USER_ACCOUNTS } from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
    userAccounts: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_USER_ACCOUNTS: {
            return {
                ...state,
                userAccounts: action.payload,
            };
        }
        default:
            return state;
    }
};
